import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import PlaylistRemoveRoundedIcon from '@mui/icons-material/PlaylistRemoveRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import { maskCpfCnpj } from '../../utils/maskCpfCnpj';

const CancelarAcordo = () => {
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitCancelarAcordo (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({ documento: cpfCnpj });
        const response = await fetchFlask('cancelarAcordo', body);

        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
        if (response.status === 'success') {
            setCpfCnpj('');
        }
        setIsSubmit(false);
    }

    const completedFields = [cpfCnpj].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Cancelar Acordo
            </PageHeader>

            <form action='' method='POST' id='formCancelarAcordo' onSubmit={submitCancelarAcordo} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Cancelamento de acordo ativo</h2>
                        </Box>
                        <p>
                            Informe o CPF ou CNPJ do cliente para cancelar qualquer acordo financeiro ativo vinculado ao cadastro.
                        </p>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <ManageAccountsRoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Identificação do cliente</strong>
                            </Box>
                        </Box>

                        <Box className='ui-input-strip'>
                            <TextField
                                required
                                label='CPF ou CNPJ'
                                value={cpfCnpj}
                                inputProps={{ maxLength: 18 }}
                                onChange={(e) => setCpfCnpj(maskCpfCnpj(e.target.value))}
                            />
                        </Box>
                    </Box>

                    <Box className='ui-impact'>
                        <WarningAmberRoundedIcon />
                        <Box>
                            <strong>Ação direta no acordo vigente</strong>
                            <span>O envio consulta o cliente informado e solicita o cancelamento dos acordos ativos encontrados para esse documento.</span>
                        </Box>
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão do cancelamento</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>CPF/CNPJ</span>
                            <strong className={!cpfCnpj ? 'is-empty' : undefined}>{cpfCnpj || 'Não informado'}</strong>
                        </Box>
                        <Box>
                            <span>Operação</span>
                            <strong>Cancelar acordo ativo</strong>
                        </Box>
                        <Box>
                            <span>Escopo</span>
                            <strong>Cliente completo</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <WarningAmberRoundedIcon />
                        <p>
                            Revise o documento antes de confirmar. A operação será aplicada aos acordos ativos retornados para esse cliente.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<PlaylistRemoveRoundedIcon />}>
                        Cancelar Acordo
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default CancelarAcordo;
